import { Pipe, PipeTransform, Inject } from '@angular/core';

export interface DisplayNameOptions {
  loggedAccountId?: number;
  showTitle?: boolean;
  shortened?: boolean;
}

@Pipe({
  name: 'displayName',
})

export class DisplayNamePipe implements PipeTransform {

  constructor(
    @Inject('$translate') private $translate,
    @Inject('AccountService') private accountService,
  ) {}

  transform(account: any, options: DisplayNameOptions = {}) {
    let displayName = '';

    if (options.showTitle === undefined) {
      options.showTitle = true;
    }

    if (account && account.first_name && account.last_name) {
      account.firstName = account.first_name;
      account.lastName = account.last_name;
    }

    if (account && account.firstName && account.lastName) {
      if (this.accountService.isDoctor(account) && options.showTitle) {
        displayName += `${this.$translate.instant('display_name.doctor')} `;
      }

      if (options.shortened) {
        displayName += account.firstName.substr(0, 1) + '.';
      } else {
        displayName += `${account.firstName}`;
      }

      displayName += ` ${account.lastName}`;

      if (options.loggedAccountId && account.id === options.loggedAccountId) {
        displayName += ' ' + this.$translate.instant('display_name.you');
      }
    }

    return displayName;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/display-name.pipe.ts